var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYouxiangMian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tongyong_youxiang_mian_svg__filter0_b_5179_55127)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 14,
    height: 12,
    rx: 1.333,
    fill: "#3F465C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.444,
    y: 2.444,
    width: 13.111,
    height: 11.111,
    rx: 0.889,
    stroke: "#3F465C",
    strokeWidth: 0.889,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.493 4.004l-4.05 2.7a.8.8 0 01-.887 0L3.51 4.007",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tongyong_youxiang_mian_svg__filter0_b_5179_55127",
    x: -1.37,
    y: -0.371,
    width: 18.741,
    height: 16.741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 1.185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5179_55127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_5179_55127",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_youxiang_mian.285620e4.svg";
export { SvgTongyongYouxiangMian as ReactComponent };